/**
 * @file Provides MobizCommonSettingsModule.
 */
import { MobizCommonCoreModule } from '../core';
import { ModuleWithProviders, NgModule, Provider } from '../injection';

import { IMobizSettingsService } from './interfaces/mobiz-settings.interface';
import { ISynchronizationSettingsService } from './interfaces/synchronization-settings.interface';
import { ISystemSettingsService } from './interfaces/system-settings.interface';
import { MobizSettingsService } from './services/mobiz-settings.service';
import { SynchronizationSettingsService } from './services/synchronization-settings.service';
import { SystemSettingsService } from './services/system-settings.service';

@NgModule({
  declarations: [],
  exports: [],
  imports: [
    MobizCommonCoreModule,
  ],
})
export class MobizCommonSettingsModule {
  public static readonly PROVIDERS: Provider[] = [
    {
      provide: IMobizSettingsService,
      useClass: MobizSettingsService,
    },
    {
      provide: ISynchronizationSettingsService,
      useClass: SynchronizationSettingsService,
    },
    {
      provide: ISystemSettingsService,
      useClass: SystemSettingsService,
    },
  ];

  /**
   * Returns the module along with its dependent providers.
   */
  public static forRoot(): ModuleWithProviders<MobizCommonSettingsModule> {
    return {
      ngModule: MobizCommonSettingsModule,
      providers: MobizCommonSettingsModule.PROVIDERS,
    };
  }
}
